import { z } from 'zod';

/**
 * The original domain event behind an analytics capture that went out without
 * the member's eligibility person id: what a later re-send rebuilds the capture
 * from. The envelope's shape, not its meaning — the event type is validated
 * against the catalogue where it is rebuilt.
 */
export const unanchoredCaptureEnvelopeSchema = z
  .object({
    id: z.string().min(1).max(200),
    type: z.string().min(1).max(128),
    source: z.string().min(1).max(200),
    time: z.string().datetime(),
    data: z.record(z.string(), z.unknown()),
  })
  .strict();

export type UnanchoredCaptureEnvelope = z.infer<typeof unanchoredCaptureEnvelopeSchema>;

/**
 * Event types of which only a member's first unanchored capture is kept for a
 * re-send: a member's first app session is the one Iterable journeys key on,
 * and re-sending every session from before the first eligibility match would
 * flood journeys with back-dated sessions. The partial unique index on
 * `analytics_unanchored_captures` enforces it; this list is what it covers.
 */
export const FIRST_ONLY_UNANCHORED_CAPTURE_TYPES = ['member.session.started'] as const;

/** How long a recorded capture is kept: after its re-send, or unsent once captured. */
export const UNANCHORED_CAPTURE_RETENTION_DAYS = 30;
